import { Component, Injectable, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/core/core-config.service';
import { CreateSiteInfoApiClientRequest } from '../models/create-siteinfo-api-client.model';
import { ClientService } from '../services/client.service';
import { UserService } from '../services/user.service';

@Component({
    selector: 'create-client',
    templateUrl: './create-siteinfo-api-client.component.html',
    standalone: false
})

export class CreateSiteInfoApiClientComponent {

    createClient: CreateSiteInfoApiClientRequest = new CreateSiteInfoApiClientRequest();

    constructor(
        private configService: ConfigService,
        private router: Router,
        public clientService: ClientService) {

            this.createClient.siteInfoApiBaseUrl = configService.config.siteInfoApiBaseUrl;
        }


    ngOnInit(): void {
        console.log("ngOnInit()");
    }

    create() {        
        this.clientService.createClient(this.createClient).then(() => {
            this.router.navigate(['/listClients']);
        }, (error) => {
            console.log(error);
            alert('Something went wrong.');
        });
    }

}
